module.exports = __webpack_public_path__ + "img/task.8781543f.svg";